import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import MuiDateRangePickerDay from '@mui/lab/DateRangePickerDay';
import { StaticDateRangePicker } from '@mui/lab';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { styled } from '@mui/material';
import { format } from 'date-fns';
import TAGTypography from '../TAGTypography/TAGTypography';
import { disableSunday } from './TAGPicker.type';
import { transformedColor } from '../../../constants/themehelper';

var TAGDateRangeCalendar = function TAGDateRangeCalendar(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'secondary' : _ref$color,
      displayStaticWrapperAs = _ref.displayStaticWrapperAs,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      onChange = _ref.onChange,
      tempArrayValue = _ref.tempArrayValue;
  var today = "".concat(format(new Date(), 'MMM dd'));
  var curYear = "".concat(format(new Date(), 'yyyy'));

  var DateRangePickerToolBar = function DateRangePickerToolBar() {
    var formatDate = function formatDate(date, errMsg) {
      if (date === null) {
        return errMsg;
      }

      return date && format(new Date(date), 'MMM dd');
    };

    return React.createElement(Box, {
      sx: {
        alignItems: 'center',
        padding: '12px 24px',
        backgroundColor: transformedColor(color),
        color: 'text.light'
      }
    }, tempArrayValue && React.createElement(React.Fragment, null, React.createElement(TAGTypography, {
      variant: "bodyMediumBook",
      color: "text.light"
    }, tempArrayValue[0] ? format(new Date(tempArrayValue[0]), 'yyyy') : curYear, ' ', tempArrayValue[0] && tempArrayValue[1] && format(new Date(tempArrayValue[0]), 'yyyy') !== format(new Date(tempArrayValue[1]), 'yyyy') && " - ".concat(format(new Date(tempArrayValue[1]), 'yyyy'))), React.createElement(TAGTypography, {
      variant: "h3",
      color: "text.light"
    }, tempArrayValue[1] && "".concat(tempArrayValue[0]) !== "".concat(tempArrayValue[1]) ? "".concat(formatDate(tempArrayValue[0], ''), " - ").concat(formatDate(tempArrayValue[1], '')) : "".concat(formatDate(tempArrayValue[0], today)))));
  };

  var DateRangePickerDay = styled(MuiDateRangePickerDay)(function (_ref2) {
    var isEndOfHighlighting = _ref2.isEndOfHighlighting,
        isHighlighting = _ref2.isHighlighting,
        isStartOfHighlighting = _ref2.isStartOfHighlighting,
        theme = _ref2.theme;
    return _objectSpread(_objectSpread(_objectSpread({}, isHighlighting && {
      padding: 1,
      borderRadius: 0,
      backgroundColor: '#F2F3F4'
    }), isStartOfHighlighting && {
      borderTopLeftRadius: '50%',
      borderBottomLeftRadius: '50%',
      backgroundColor: color && theme.palette[color.split('.')[0]][color.split('.')[1] || 'main'],
      color: 'white'
    }), isEndOfHighlighting && {
      borderTopRightRadius: '50%',
      borderBottomRightRadius: '50%',
      backgroundColor: color && theme.palette[color.split('.')[0]][color.split('.')[1] || 'main'],
      color: 'white'
    });
  });

  var renderDateRangePickerDay = function renderDateRangePickerDay(_date, dateRangePickerDayProps) {
    return React.createElement(DateRangePickerDay, _objectSpread(_objectSpread({}, dateRangePickerDayProps), {}, {
      sx: {
        '&& .Mui-selected': {
          backgroundColor: transformedColor(color),
          color: 'white'
        }
      }
    }));
  };

  return React.createElement(Box, {
    sx: {
      '& > div > div, & > div > div > div, & .MuiCalendarRangePicker-root': {
        boxSizing: 'border-box' // margin: '5px',

      },
      '& > div > div, & > div > div > div > div': {
        width: '100%'
      },
      '& .MuiCalendarRangePicker-root': {
        maxWidth: '370px',
        width: '100%',
        margin: 'auto',
        padding: '8px'
      },
      '& .MuiTypography-caption': {
        width: '100%',
        margin: 0
      },
      '& .PrivatePickersSlideTransition-root': {
        minHeight: 40 * 8
      },
      '& .PrivatePickersSlideTransition-root [role="row"]': {
        margin: '8px 0px'
      },
      '& .MuiDateRangePickerDay-dayWithMargin': {
        margin: 0
      },
      '& .MuiDateRangePickerDay-root': {
        width: '100%'
      },
      '& .MuiDateRangePickerDay-root > div > button': {
        width: '100%',
        aspectRatio: '1/1',
        height: 'auto'
      }
    }
  }, displayStaticWrapperAs === 'mobile' && React.createElement(DateRangePickerToolBar, null), React.createElement(StaticDateRangePicker, {
    minDate: minDate,
    maxDate: maxDate,
    className: "MuiCalendarRangePicker-root",
    shouldDisableDate: disableSunday,
    showToolbar: false,
    renderDay: renderDateRangePickerDay,
    orientation: 'landscape',
    calendars: 1,
    displayStaticWrapperAs: displayStaticWrapperAs,
    value: tempArrayValue,
    onChange: onChange,
    renderInput: function renderInput(startProps, endProps) {
      return React.createElement(React.Fragment, null, React.createElement(TextField, _objectSpread({}, startProps)), React.createElement(Box, {
        sx: {
          mx: 2
        }
      }, " to "), React.createElement(TextField, _objectSpread({}, endProps)));
    }
  }));
};

export default TAGDateRangeCalendar;